module.exports = __webpack_public_path__ + "img/menu-icon-5-1.da381135.svg";